import React from "react";
import PropTypes from "prop-types";
import { InputAdornment } from "@mui/material";
import { SlideUpModalInput } from "../views/comparison_views/molecules/SlideUpModalInput";
import { IMaskInput } from "react-imask";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, value, ...other } = props;

  return (
    <IMaskInput
      mask={Number}
      radix="."
      thousandsSeparator=","
      scale={0}
      unmask
      inputRef={ref}
      value={value.toString()}
      // DO NOT USE onChange TO HANDLE CHANGES!
      // USE onAccept INSTEAD
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      {...other}
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const MoneySlideUpModalInput = (props) => {
  return (
    <SlideUpModalInput
      {...props}
      className="money-input slide-up-modal-money-input"
      InputProps={{
        inputComponent: NumericFormatCustom,
        startAdornment: (
          <InputAdornment
            className="slide-up-money-icon-mobile-wrapper"
            position="start"
          >
            $
          </InputAdornment>
        ),
      }}
    />
  );
};
